import { defineStore } from "pinia";
import {
  getPendingCustomFoodMigrations,
  applyCustomFoodMigration,
  ignoreCustomFoodMigration,
  type SyncableCustomFoodMigrationRecord,
} from "@/services/customFoodMigrations";
import {
  removeLocalFoodSearchDoc,
  type LocalFoodEntityType,
} from "@/services/localFoodSearch";

export type { SyncableCustomFoodMigrationRecord, LocalFoodEntityType };

export const useCustomFoodMigrationsStore = defineStore(
  "customFoodMigrations",
  () => {
    async function getPending(): Promise<SyncableCustomFoodMigrationRecord[]> {
      return getPendingCustomFoodMigrations();
    }

    async function apply(id: string): Promise<void> {
      await applyCustomFoodMigration(id);
    }

    async function ignore(id: string): Promise<void> {
      await ignoreCustomFoodMigration(id);
    }

    async function removeSearchDoc(
      entityType: LocalFoodEntityType,
      entityId: string,
    ): Promise<void> {
      await removeLocalFoodSearchDoc(entityType, entityId);
    }

    return { getPending, apply, ignore, removeSearchDoc };
  },
);
